import { GoogleLogin } from "@react-oauth/google";
import { useEffect, useState } from "react";
import { post } from "../../services/api";
import { useNavigate } from "react-router";
import { activeSpinner, cancelSpinner } from "@/store/reducers/geral";
import { setInfoDialog } from "@/store/reducers/geral";
import { useDispatch } from "react-redux";

export function Socials({ idRequestBind, tokenRequestBind }) {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const navigation = useNavigate();

  useEffect(() => {
    const getProfile = async () => {
      if (!!user) {
        try {
          dispatch(activeSpinner());
          user.idRequestBind = idRequestBind;
          user.tokenRequestBind = tokenRequestBind;
          const result = await post("public/social-login", user);
          dispatch(cancelSpinner());
          if (result.error) {
            dispatch(
              setInfoDialog({
                open: true,
                descricao: result.error,
              })
            );
            return;
          }
          if (result.cpfCnpj) {
            sessionStorage.setItem(
              "dadosUsuarioLogado",
              JSON.stringify(result)
            );
            navigation("/app/area-cliente/inicio");
            return;
          }
          let url = `/app/login-social/${result.idUser}/${result.token}`;
          if (idRequestBind) {
            url += `/${idRequestBind}/${tokenRequestBind}`;
          }
          navigation(url);
        } catch (e) {
          console.log(e);
          dispatch(cancelSpinner());
          setInfoDialog({
            open: true,
            descricao:
              "Estamos atualizando nosso sistema. Por favor atualize a página e tente novamente.",
          });
        }
      }
    };
    getProfile();
  }, [idRequestBind, navigation, dispatch, tokenRequestBind, user]);

  return (
    <>
      <GoogleLogin
        onSuccess={(codeResponse) => setUser(codeResponse)}
        onError={(error) => console.log("Login Failed:", error)}
      />
    </>
  );
}
